import React from 'react';
import styled from 'styled-components';

export const AuditAreaCell = ({ value }) => <Wrap>{value}</Wrap>;

const Wrap = styled.div`
  font-weight: 700;
  color: #003366;
`;
